import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleiconPickerComponent } from './googleicon-picker.component';
import { GoogleiconPickerService } from './googleicon-picker.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';



@NgModule({
  declarations: [GoogleiconPickerComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatButtonModule,
  ],
  exports: [GoogleiconPickerComponent],
  providers: [GoogleiconPickerService]
})
export class GoogleiconPickerModule { }
